import React from 'react';
const painPoints = ['El lunes a las 8:50 todavía no sabés qué plan vas a entregar en la consulta de las 9. Y eso se nota en tu seguridad.', 'Tus pacientes llevan meses en tratamiento pero no podés mostrar una evolución clara ni justificar los cambios que estás haciendo.', 'Un paciente te pregunta "¿por qué este plan y no otro?" y tu respuesta no tiene el respaldo clínico que merecería tener.', 'El domingo a las 23:00 seguís armando planes en Excel desde cero, copiando y pegando sin criterio clínico ni personalización real.', 'Sabés que deberías cobrar más, pero no tenés un sistema profesional visible que justifique ese aumento frente a tus pacientes.', 'Cada consulta empieza desde cero. Sin protocolo, sin material listo, sin progresión medible. Y lo peor: ya te acostumbraste.'];
export function PainPoints() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(254,242,242) 0%, rgb(254,242,242) 15%, rgb(254,242,242) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-185">
      <div className="mx-auto max-w-4xl" data-id="element-186">

        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-187">
          ¿Te sentís identificado?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-188">
          Esto le pasa al 90% de los nutricionistas
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-189">
          No es falta de conocimiento. Es falta de un sistema.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-190">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-191">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-192">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-193">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-green-700 m-0 mb-6" data-id="element-194">
          ¿Cuántas consultas más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(34, 197, 94), rgba(255, 255, 255, 0))'
      }} data-id="element-195" />

      </div>
    </section>;
}